<div class="message-document">
  <button
    mat-fab
    class="message-document-btn"
    (click)="downloadDocument()"
  >
    <mat-icon class="file-icon"></mat-icon>
  </button>
  <div class="message-document-content">
    @if(message.id === currentMessageId) {
      @if (uploadProgressService.currentProgress() > 0) {
        <app-telegram-upload-status
          [useGridLayout]="false"
        />
      }
    }

    @if (!currentMessageId) {
      <div class="message-document-name">
        {{ message.content.document?.fileName }}
      </div>
      <div class="message-document-size">
        {{ message.content.document?.document?.size | fileSize }}
      </div>
    }
  </div>
</div>
